import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from '../context/AuthContext';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { authState } = useAuthContext();

    // if (!authState.isAuthenticated) {
    //     return <Navigate to="/" />;
    // }

    return <>{children}</>;
};

export default ProtectedRoute; 